import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await login({ username, password });

        if (result.success) {
            navigate('/');
        } else {
            if (result.requiresApproval) {
                setError(
                    `Shift overlap detected. ${result.existingShift.operator} has an active shift. ` +
                    `Admin approval required.`
                );
            } else {
                setError(result.error);
            }
        }

        setLoading(false);
    };

    return (
        <main className="login-container">
            <div className="login-shell">
                <div className="login-brand">
                    <svg className="login-mark" viewBox="0 0 32 32" aria-hidden="true">
                        <rect width="32" height="32" rx="7" />
                        <path d="M10 23V9h12M10 16h8" />
                    </svg>
                    <span>FactoryDash</span>
                </div>

                <div className="login-card">
                    <div className="login-header">
                        <h1>Sign in to start your shift</h1>
                        <p>Film production tracker · Manufacturing operations</p>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        {error && (
                            <div className="alert alert-error" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="form-group">
                            <label className="form-label" htmlFor="login-username">Username</label>
                            <input
                                id="login-username"
                                type="text"
                                className="form-input"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="e.g. operator1"
                                autoComplete="username"
                                autoCapitalize="none"
                                spellCheck={false}
                                required
                                autoFocus
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="login-password">Password</label>
                            <input
                                id="login-password"
                                type="password"
                                className="form-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                autoComplete="current-password"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary btn-lg login-submit"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    Signing in…
                                </>
                            ) : (
                                'Log in & start shift'
                            )}
                        </button>
                    </form>
                </div>

                <p className="login-foot">Having trouble signing in? Ask your shift supervisor or an admin to reset your account.</p>
            </div>
        </main>
    );
};

export default Login;
